/**
 * This file will configure various resources for your application.
 * - Logging to Sumologic (More configuration required - see below)
 * - Analytics tracking through Adobe Target Events
 * - Daxi (The Origin Digital http request library)
 *
 * Anything else required before your app is loaded can be included in this
 * file.
 */
import { injectGlobal } from "styled-components";
import SumoLogger from "sumo-logger";

import { configAnalytics, configSumo } from "@origin-digital/reporting-client";
import { configFetch, configFetchCache } from "@origin-digital/daxi";

import { config, appName } from "./config";

declare const __DEV__: boolean;

if (__DEV__) {
  // eslint-disable-next-line babel/no-unused-expressions
  injectGlobal`
    html {
      background-color: #f1f1f1;
      height:100%;
    }
    body {
      margin: 0;
      font-family: gordita, sans-serif;
      height: 100%;
    }
    body > div {
      height: 100%;
    }
  `;
}

const envAppName = `${appName}-${config.env}`;

configAnalytics({
  appName,
  debugToConsole: config.analyticsDebugToConsole,
});

configSumo({
  SumoLogger,
  appName: envAppName,
  consoleLogLevel: config.logLevelConsole as LogLevel,
  endpoint: `https://collectors.au.sumologic.com/receiver/v1/${config.sumoCollectorKey}`,
  sendOnErrors: config.sumoSendOnErrors,
  sourceEnv: config.env as EnvironmentNames,
  sumoLogLevel: config.logLevelSumo as LogLevel,
});

/* eslint-disable-next-line no-undef */
configFetch({ host: config.apiBasePath, disableAuthCheck: __DEV__ });
configFetchCache({ disableCache: __DEV__ });
